import { render, staticRenderFns } from "./call_patient.vue?vue&type=template&id=6257eac9&scoped=true"
import script from "./call_patient.vue?vue&type=script&lang=js"
export * from "./call_patient.vue?vue&type=script&lang=js"
import style0 from "./call_patient.vue?vue&type=style&index=0&id=6257eac9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6257eac9",
  null
  
)

export default component.exports